const API_URL = process.env.REACT_APP_API_URL;

async function getJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch performance data");
  }
  return await response.json();
}

export const getFilterOptions = async (courseId, batchId) => {
  const params = new URLSearchParams();
  if (courseId) params.set("courseId", courseId);
  if (batchId) params.set("batchId", batchId);
  const res = await getJson(`${API_URL}/api/performance/filter-options?${params.toString()}`);
  return res.data;
};

export const getPerformanceData = async (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const res = await getJson(`${API_URL}/api/performance/data?${params.toString()}`);
  return res.data;
};

// ─── Test performance ─────────────────────────────────────────────────────────

const buildParams = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return params;
};

export const getTestPerformance = async (filters = {}) => {
  const res = await getJson(`${API_URL}/api/test-performance?${buildParams(filters).toString()}`);
  return res.data;
};

export const getTestPerformanceDetails = async (filters = {}) => {
  const res = await getJson(`${API_URL}/api/test-performance/details?${buildParams(filters).toString()}`);
  return res.data;
};

export const getTestPerformanceFilterOptions = async (filters = {}) => {
  const res = await getJson(`${API_URL}/api/test-performance/filter-options?${buildParams(filters).toString()}`);
  return res.data;
};

// The Trainer app's Performance Review metrics, recomputed for the Admin panel.
export const getPerformanceReview = async (filters = {}) => {
  const res = await getJson(`${API_URL}/api/performance/review?${buildParams(filters).toString()}`);
  return res.data;
};

// Test Score Summary for the Test Details page.
export const getTestScoreSummary = async (testId) => {
  const res = await getJson(`${API_URL}/api/test-performance/summary?testId=${encodeURIComponent(testId)}`);
  return res.data;
};
